namespace TabAurous.ProductDevelopment {
    export interface SpecSheetBOMForm {
        ItemTypeId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        BOMProductId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BOMAttributeId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ItemType: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        GroupSieveId: StoneSieveLookup;
        SieveId: StoneSieveLookup;
        MetalColorId: Serenity.LookupEditor;
        TextureId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        SettingId: Serenity.LookupEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Purity: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: WeightEditor;
        Parts: Serenity.IntegerEditor;
        GrossWeight: Serenity.DecimalEditor;
        PointerWeight: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        BomRate: AmountEditor;
        Markup: Serenity.DecimalEditor;
        BomAmount: AmountEditor;
        CCBomAmount: AmountEditor;
        Remarks: Serenity.StringEditor;
        CostMethodId: Serenity.LookupEditor;
    }

    export class SpecSheetBOMForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.SpecSheetBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SpecSheetBOMForm.init)  {
                SpecSheetBOMForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = StoneSieveLookup;
                var w6 = s.DecimalEditor;
                var w7 = WeightEditor;
                var w8 = AmountEditor;

                Q.initFormType(SpecSheetBOMForm, [
                    'ItemTypeId', w0,
                    'ProductId', w1,
                    'ProductTypeId', w2,
                    'BOMProductId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BOMAttributeId', w1,
                    'ProductCode', w1,
                    'ItemType', w1,
                    'Attribute', w1,
                    'Lab', w2,
                    'CertificateNo', w1,
                    'KaratId', w2,
                    'ShapeId', w2,
                    'StoneSizeId', w2,
                    'GroupSieveId', w5,
                    'SieveId', w5,
                    'MetalColorId', w2,
                    'TextureId', w2,
                    'StoneColorId', w2,
                    'QualityId', w2,
                    'SettingId', w2,
                    'StoneCutId', w2,
                    'StonePolishId', w2,
                    'StoneSymmetryId', w2,
                    'StoneFluorescenceId', w2,
                    'StoneCuletId', w2,
                    'StoneGirdleId', w2,
                    'StoneTable', w1,
                    'StoneDepth', w1,
                    'Purity', w6,
                    'Pieces', w0,
                    'Weight', w7,
                    'Parts', w0,
                    'GrossWeight', w6,
                    'PointerWeight', w6,
                    'PureWeight', w6,
                    'CalcOnId', w2,
                    'BomRate', w8,
                    'Markup', w6,
                    'BomAmount', w8,
                    'CCBomAmount', w8,
                    'Remarks', w1,
                    'CostMethodId', w2
                ]);
            }
        }
    }
}
